export default "__VITE_ASSET__BnetAvf2__"